<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="pb-12">
          <setup-department-container-view />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupDepartmentContainerView: () => import('@/components/hris/setup/department/ContainerView'),
    },
    metaInfo () {
      return {
        title: 'Setup Department',        
      }
    },
  }
</script>
